import { apiClient } from '@services/api';

/**
 * REV-1169: a tracked place's crawl render options — hash-route identity and
 * the SPA render-settle window. Each field is optional; an unset field leaves
 * the crawl on afixt-spider's own deployment default.
 */
export interface CrawlConfig {
  settleQuietMs?: number;
  settleTimeoutMs?: number;
  hashRoutes?: boolean;
}

/** Bounds and defaults the editor needs, returned by the GET endpoint. */
export interface CrawlConfigMeta {
  maxSettleQuietMs: number;
  maxSettleTimeoutMs: number;
  defaultHashRoutes: boolean;
}

interface CrawlConfigResponse {
  success: boolean;
  data: { config: CrawlConfig; meta?: CrawlConfigMeta };
}

const ctxBase = (orgId: string, contextId: string) =>
  `/v1/organizations/${orgId}/contexts/${contextId}/crawl-config`;

export const crawlConfigService = {
  async getContextCrawlConfig(
    orgId: string,
    contextId: string
  ): Promise<{ config: CrawlConfig; meta?: CrawlConfigMeta }> {
    const res = await apiClient.get<CrawlConfigResponse>(ctxBase(orgId, contextId));
    return res.data;
  },

  async putContextCrawlConfig(
    orgId: string,
    contextId: string,
    config: CrawlConfig
  ): Promise<CrawlConfig> {
    const res = await apiClient.put<CrawlConfigResponse>(ctxBase(orgId, contextId), { config });
    return res.data.config;
  },
};
